<template>
    <button
        :disabled="disabled"
        :type="type"
        :class="[classes, colors, weight]"
        class="disabled:opacity-25 disabled:cursor-not-allowed inline-flex items-center justify-center border focus-style transition duration-button-hover"
    >
        <slot />
    </button>
</template>

<!--
optional:
 	 uppercase tracking-widest
-->
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) =>
                ['custom', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'].includes(value),
        },
        colors: {
            type: [String, Array, Object],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        weight: {
            type: String,
            default: 'font-normal',
        },
        roundedPill: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        classes() {
            if (this.size === 'xs') {
                return [
                    'py-0.5',
                    this.roundedPill ? 'rounded-full px-2' : 'rounded-md px-1',
                    'text-base md:text-xs',
                ]
            } else if (this.size === 'sm') {
                return [
                    'py-1.5 px-3',
                    this.roundedPill ? 'rounded-full' : 'rounded-button',
                    'text-base',
                ]
            } else if (this.size === 'md') {
                return [
                    'py-2 px-4',
                    this.roundedPill ? 'rounded-full' : 'rounded-button',
                    'text-base',
                ]
            } else if (this.size === 'lg') {
                return [
                    'p-4',
                    this.roundedPill ? 'rounded-full' : 'rounded-button',
                ]
            } else if (this.size === 'xl') {
                return [
                    'px-5 py-3',
                    this.roundedPill ? 'rounded-full' : 'rounded-button',
                    'text-lg',
                ]
            } else if (this.size === '2xl') {
                return [
                    this.roundedPill ? 'rounded-full' : 'rounded-button',
                    'text-lg',
                ]
            }
        },
    },
}
</script>
